"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyProviderImpl = void 0;
const events_strategy_1 = require("./events-strategy");
const summaries_strategy_1 = require("./summaries-strategy");
class StrategyProviderImpl {
    getStrategy(type, session, params) {
        if (type === 'Events') {
            return new events_strategy_1.EventsStrategy(session, params);
        }
        return new summaries_strategy_1.SummariesStrategy(session, params);
    }
}
exports.StrategyProviderImpl = StrategyProviderImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyYXRlZ3ktcHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvZGF0YS1zdHJhdGVnaWVzL3N0cmF0ZWd5LXByb3ZpZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHVEQUFtRDtBQUNuRCw2REFBeUQ7QUFFekQsTUFBYSxvQkFBb0I7SUFDdEIsV0FBVyxDQUNkLElBQWlELEVBQ2pELE9BQWdCLEVBQ2hCLE1BQTJDO1FBRTNDLElBQUksSUFBSSxLQUFLLFFBQVEsRUFBRSxDQUFDO1lBQ3BCLE9BQU8sSUFBSSxnQ0FBYyxDQUFDLE9BQU8sRUFBRSxNQUFNLENBQUMsQ0FBQztRQUMvQyxDQUFDO1FBRUQsT0FBTyxJQUFJLHNDQUFpQixDQUFDLE9BQU8sRUFBRSxNQUE0QyxDQUFDLENBQUM7SUFDeEYsQ0FBQztDQUNKO0FBWkQsb0RBWUMifQ==